import type { VariantWithStockDTO } from "@/modules/inventory/domain/contracts";

const CSV_HEADERS = [
  "variantId",
  "sku",
  "productName",
  "quantity",
  "lowStockThreshold",
] as const;

function escapeCsvCell(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return "";
  const s = String(value);
  if (
    s.includes(",") ||
    s.includes('"') ||
    s.includes("\n") ||
    s.includes("\r")
  )
    return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/**
 * Build CSV content for stock template (UTF-8 with BOM for Excel).
 */
export function buildStockTemplateCsv(rows: VariantWithStockDTO[]): string {
  const headerLine = CSV_HEADERS.join(",");
  const dataLines = rows.map((row) => {
    const productName = row.product?.name?.lo ?? row.product?.name?.en ?? "";
    return [
      escapeCsvCell(row.variantId),
      escapeCsvCell(row.sku),
      escapeCsvCell(productName),
      escapeCsvCell(row.quantity),
      escapeCsvCell(
        row.lowStockThreshold === null ? "" : row.lowStockThreshold,
      ),
    ].join(",");
  });
  const body = [headerLine, ...dataLines].join("\r\n");
  return "\uFEFF" + body;
}

/**
 * Trigger download of a CSV file.
 */
export function downloadCsv(content: string, filename: string): void {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/**
 * Generate filename for stock template export.
 */
export function stockTemplateFilename(): string {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `stock-template-${y}-${m}-${d}.csv`;
}
